import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Modal, Validators } from '@softline/ui-core';
import { Subkunde } from '../../types/subkunde';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { InputComponent } from '@softline/ui-core';
import { ToggleSwitchComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'soft-edit-subkunde-dialog',
    imports: [ReactiveFormsModule,
    InputComponent,
    ToggleSwitchComponent,
    TranslatePipe],
    templateUrl: './edit-subkunde-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./edit-subkunde-dialog.component.css']
})
export class EditSubkundeDialogComponent
  implements OnInit, Modal<Partial<Subkunde>>
{
  private _subkunde: Partial<Subkunde> = {};

  form = new FormGroup({
    name: new FormControl<string>('', [Validators.required()]),
    aktiv: new FormControl(true, [Validators.required()]) });

  get subkunde(): Partial<Subkunde> {
    return this._subkunde;
  }
  set subkunde(value: Partial<Subkunde>) {
    this._subkunde = value;
    this.form.patchValue(value);
  }

  private close!: (subkunde: Partial<Subkunde>) => void;

  constructor() {}

  ngOnInit(): void {}

  registerCloseHandler(handler: (result: Partial<Subkunde>) => void): void {
    this.close = handler;
  }

  onSubmit(value: Partial<Subkunde>): void {
    this.close(value);
  }
}
